import { createAction, ActionsUnion, GraphqlError } from '../utils/types';
import {
  ArticlePageQuery,
  CategoryPageQuery,
  HomePageQuery,
  SearchQuery,
} from '@elevio-kb/queries/dist/types';
import { ErrorStatus } from '../reducers/page';

export enum ActionTypes {
  PAGE_NAV_START = 'page::navStart',
  PAGE_NAV_COMPLETE = 'page::navComplete',
  PAGE_NAV_ERROR = 'page::navError',
}

// Pages that need to load data
export type PageNavStart =
  | { pageType: 'home'; path: string }
  | { pageType: 'category'; path: string; categoryId: string }
  | { pageType: 'article'; path: string; articleId: string }
  | {
      pageType: 'search';
      path: string;
      searchTerm: string;
    };

export type PageNavComplete =
  | { pageType: 'home'; path: string; data: HomePageQuery }
  | {
      pageType: 'category';
      path: string;
      categoryId: string;
      data: CategoryPageQuery;
    }
  | {
      pageType: 'article';
      path: string;
      articleId: string;
      data: ArticlePageQuery;
    }
  | {
      pageType: 'search';
      path: string;
      searchTerm: string;
      data: SearchQuery;
    }
    | {
      pageType: 'error404';
      path: string;
    }
    | {
      pageType: 'error401';
      path: string;
    }
  | {
      pageType: 'extra';
      path: string;
    };

export type PageNavError =
  | {
      pageType: 'home';
      path: string;
      errorStatus: ErrorStatus;
      errors: GraphqlError[];
    }
  | {
      pageType: 'category';
      path: string;
      categoryId: string;
      errorStatus: ErrorStatus;
      errors: GraphqlError[];
    }
  | {
      pageType: 'article';
      path: string;
      articleId: string;
      errorStatus: ErrorStatus;
      errors: GraphqlError[];
    }
  | {
      pageType: 'search';
      path: string;
      searchTerm: string;
      errorStatus: ErrorStatus;
      errors: GraphqlError[];
    }
  | {
      pageType: 'extra';
      path: string;
      errorStatus: ErrorStatus;
      errors: GraphqlError[];
    }
  | {
      pageType: 'error';
      path: string;
      errorStatus: ErrorStatus;
      errors: GraphqlError[];
    };

export const Actions = {
  pageNavStart: (data: PageNavStart) =>
    createAction(ActionTypes.PAGE_NAV_START, data),
  pageNavComplete: (data: PageNavComplete) =>
    createAction(ActionTypes.PAGE_NAV_COMPLETE, data),
  pageNavError: (data: PageNavError) =>
    createAction(ActionTypes.PAGE_NAV_ERROR, data),
};

export type Actions = ActionsUnion<typeof Actions>;
